import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { cardCopy, cardHover } from '../../styles/theme';
import {
  linkType,
  responsiveImageType,
} from '../../propTypes';
import DeferredCard from '../DeferredCard';
import stylePlaceholders from '../../styles/placeholders';
import renderNewlinesAsJsxBreaks from '../../helpers/renderNewlinesAsJsxBreaks';
import LineClamp from '../LineClamp';

const Tile = ({
  classes, className, link, copy, id, image, hideCopy,
}) => (
  <DeferredCard
    aspect={1}
    className={cn(className, classes.tile, !id && classes.placeholder)}
    image={image}
    imageClassName={classes.image}
    link={link}
    ready={!!id}
  >
    {!hideCopy && [
      <LineClamp key="copy">
        <p className={classes.copy}>
          {renderNewlinesAsJsxBreaks(copy)}
        </p>
      </LineClamp>,
      !id && <p key="copy-placeholder" className={classes.copyPlaceholder2} />,
    ]}
  </DeferredCard>
);

export const tileShape = {
  copy: PropTypes.string,
  id: PropTypes.string,
  image: responsiveImageType,
  link: linkType,
};

Tile.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  ...tileShape,
  hideCopy: PropTypes.bool,
};

export const tileDefaultProps = {
  copy: undefined,
  image: undefined,
  link: undefined,
  hideCopy: false,
};

Tile.defaultProps = {
  className: undefined,
  ready: false,
  ...tileDefaultProps,
};

export default injectSheet({
  tile: {
    '& a': {
      ...cardHover('$image'),
    },
  },
  image: {
    marginBottom: theme.padding.gutter,
  },
  copy: {
    ...cardCopy,
    [theme.breakpoints.up('md')]: {
      maxWidth: '95%',
    },
    marginBottom: 0,
  },
  copyPlaceholder2: {
    extend: 'copy',
  },
  ...stylePlaceholders({
    copy: { text: true, width: '90%' },
    copyPlaceholder2: { text: true, width: '70%' },
  }),
})(Tile);
